import type { BaseController } from '@infra/controllers/base.controller';
import { type UserPresenceStatus } from '@main/sf-connector/user-presence-status-store';
import type { StatusSyncCrmToAircallUsecase } from '@usecases/status-sync-crm-to-aircall.usecase';

export interface StatusSyncCrmToAircallInput extends UserPresenceStatus {
  statusApiName: string;
}

export type StatusSyncCrmToAircallOutput = void;

export class StatusSyncCrmToAircallController
  implements
    BaseController<StatusSyncCrmToAircallInput, StatusSyncCrmToAircallOutput>
{
  constructor(private usecase: StatusSyncCrmToAircallUsecase) {}

  async handle(
    status: StatusSyncCrmToAircallInput,
  ): Promise<StatusSyncCrmToAircallOutput> {
    await this.usecase.run(status);
  }
}
